/* eslint-disable no-useless-escape */
import React, { useContext, FC } from 'react'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import { Button, Link } from '@material-ui/core'
import SignupLayout from '../../layout'
import { SignupContext } from '../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../utils/constants'

const Welcome: FC = () => {
  const { setSignupStep } = useContext(SignupContext)
  const history = useHistory()

  const gotoTemplate = (): void => {
    setSignupStep(SIGNUP_STEPS.TEMPLATE)
    history.push('/client/templates')
  }

  return (
    <SignupLayout page="welcome">
      <img src="/assets/maverick-logo.png" alt="app-logo" className="logo" />
      <p className="subtitle">Welcome to your Templating Wingman.</p>
      <p className="description">
        With your help, Maverick will create your First Touch Master Templates for you, tailored to
        your business. Maverick will ask a set of questions or fill in the blanksto start.
        <br />
        <br />
        Once completed Maverick will provide Mission templates for you to choose from and implement,
        with a click of a button.
      </p>
      <div className="button-container">
        <Button
          size="large"
          variant="contained"
          color="secondary"
          style={{ marginRight: 10 }}
          onClick={gotoTemplate}
        >
          Let&apos;s Go!
        </Button>
        <Button size="large" onClick={gotoTemplate}>
          press Enter
        </Button>
      </div>
      <Link component={RouterLink} to="/client/writer" className="goBack">
        Go Back.
      </Link>
    </SignupLayout>
  )
}
export default Welcome
